import { render } from "./AdolescentFamilyScreening.vue?vue&type=template&id=b7fd815a"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__